<template>
  <hr class="border-gray-100" />
</template>

<script>
export default {
  name: 'AtomHR',
}
</script>
